import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { IconProps } from '@bl/components';
import { BlFrontendBaseComponent } from './bl-frontend-base.component';

@Component({
  selector: 'bl-frontend-icon',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
})
export class BlFrontendIconComponent extends BlFrontendBaseComponent<IconProps> {
  @Input() name: IconProps['name'];
  @Input() variant: IconProps['variant'] = 'regular';
  @Input() animation: IconProps['animation'] = 'none';
  @Input() size: IconProps['size'] = 'default';
  @Input() color: 'normal' | 'warning' | 'error' | 'success' | 'info' = 'normal';

  @HostBinding('class') get hostClasses(): string {
    return this.getColorClass();
  }

  private getColorClass(): string {
    switch (this.color) {
      case 'warning':
        return 'text-warning-mid-2';
      case 'error':
        return 'text-danger-mid-2';
      case 'success':
        return 'text-success-mid-2';
      case 'info':
        return 'text-info-mid-2';
      default:
        return '';
    }
  }

  protected override getComponentName(): string {
    return 'Icon';
  }

  protected override getProps(): IconProps {
    return {
      name: this.name,
      variant: this.variant,
      animation: this.animation,
      size: this.size,
    };
  }
}
